/**
 * A finished transcript joined onto whatever was already in the field, the
 * way a person would type it: one space between, no stray whitespace.
 *
 * The transcript lands in one go once the user stops — no word-by-word
 * reveal, no streaming partials.
 */
export function joinTranscript(base: string, addition: string): string {
  const trimmedBase = base.replace(/\s+$/, '');
  const trimmedAddition = addition.trim();
  if (!trimmedBase) return trimmedAddition;
  if (!trimmedAddition) return trimmedBase;
  return `${trimmedBase} ${trimmedAddition}`;
}
